<template>
  <div class="fc-notification-applies-when" :data-testid="dataTestid">
    <div>
      <span v-if="lines.kind === 'category'">Category is <strong>{{ lines.value }}</strong></span>
      <span v-else>Priority is <strong>{{ lines.value }}</strong></span>
    </div>
    <div v-if="lines.sub" class="fc-notification-applies-when__sub">{{ lines.sub }}</div>
  </div>
</template>

<script>
import { escalationAppliesWhenLines } from '../../../utils/notificationNameUtils';

export default {
  name: 'NotificationAppliesWhenCell',
  props: {
    item: { type: Object, default: () => ({}) },
    categoryLookups: { type: Array, default: () => [] },
    dataTestid: { type: String, default: 'notification-applies-when-cell' },
  },
  computed: {
    lines() {
      return escalationAppliesWhenLines(this.item, this.categoryLookups);
    },
  },
};
</script>
